// store-runtime.js — shared browser-resource state for the split runtime modules.
//
// This module is a dependency LEAF: it must never import from any runtime-*.js module.
// Every mutable handle that more than one runtime module touches (audio graph, camera
// stream, MediaRecorder, cross-module timers) lives here, so the runtime modules only
// ever point "down" at this file and import cycles stay impossible.
//
// ES module exports are immutable bindings from the importer's side, so each `export let`
// ships with a setter — importers read the live binding, writers go through the setter.

// ─── Cross-module runtime flags (mic, auto-split, recording lifecycle) ──
export const runtimeState = {
  _scorerMicActive: false,
  _autoSplitting: false,
  _splitOverNumber: null,
  _autoSplitCountdown: 0,
  _chainRestartTimer: null,
  _callingTimeInterval: null
};

// ─── Camera / canvas handles ────────────────────────────────────────────
let overlayCtx = null;
export let camStream = null;
export let camZoomCap = null;
export let currentZoom = 1;
export function setCamZoom(z) { currentZoom = z; }
export function setCamStream(stream) { camStream = stream; }
export function setCamZoomCap(v) { camZoomCap = v; }
export function setOverlayCtx(ctx) { overlayCtx = ctx; }
export function getOverlayCtx() { return overlayCtx; }

// ─── Recording handles ──────────────────────────────────────────────────
export let mediaRecorder = null;
export function _setMediaRecorder(v) { mediaRecorder = v; }
export let recTickId = null;
export function setRecTickId(v) { recTickId = v; }
export let wakeLock = null;
export function setWakeLock(v) { wakeLock = v; }
export let _autoSplitTimer = null;
export function setAutoSplitTimer(v) { _autoSplitTimer = v; }

// ─── End-of-match auto-sequence timers ──────────────────────────────────
// Set by runtime-match-flow, cancelled from recording stop / leaving the
// recording screen — parking them here keeps those modules decoupled.
let _endMatchTimer1 = null;
let _endMatchTimer2 = null;
export function setEndMatchTimer1(v) { _endMatchTimer1 = v; }
export function setEndMatchTimer2(v) { _endMatchTimer2 = v; }
export function _cancelEndMatchTimers() {
  if (_endMatchTimer1) { clearTimeout(_endMatchTimer1); _endMatchTimer1 = null; }
  if (_endMatchTimer2) { clearTimeout(_endMatchTimer2); _endMatchTimer2 = null; }
}

// ─── Web Audio graph ────────────────────────────────────────────────────
export let _audioCtx = null;
export let _audioDest = null;
export let _micSource = null;
export let _micGainNode = null;
export let _audioKeepAlive = null;  // silent ConstantSourceNode keeping the recorded audio track alive
export let _audioResumeTimer = null; // periodic resume() during recording (mobile auto-suspend guard)
export function _setAudioCtx(v) { _audioCtx = v; }
export function _setAudioDest(v) { _audioDest = v; }
export function _setMicGainNode(v) { _micGainNode = v; }
export function _setAudioKeepAlive(v) { _audioKeepAlive = v; }
export function setMicSource(v) { _micSource = v; }
export function setAudioResumeTimer(v) { _audioResumeTimer = v; }
